import { apiUrl } from 'libs/apiUrl';
import fetch from "libs/fetchWithAuth";
const _baseUrl = apiUrl('/api/ext/config');

class Configs {
	static get(key, req) {
		return fetch(_baseUrl + '/get/' + key, {}, req);
	}

	static getAuth(key, req) {
		return fetch(_baseUrl + '/get-auth/' + key, {}, req);
	}

	static set(key, value, req) {
		return fetch(_baseUrl + '/set', {
			method: 'POST',
			body: JSON.stringify({
				key: key,
				value: value
			}),
		}, req);
	}
}

export default Configs;
